import { environment } from '../../../../../environments/environment';
import { AppConstants } from '../services/api/app-constants';

export const daVehicleMaster = {
  query: `
  query DaVehicleMasters($user_id: String) {
    listDaVehicleMasters(filter:{
      user_id : { eq : $user_id}
    }) {
      items {
        id
        driver_id
        user_id
        user_name
        vehicle_model
        vehicle_no
        geofence_limit
        notification_flag
        user_phone_number
        home_address {elat elong address lat long}
        office_address {elat elong address lat long}
        status
        agency_type
        driver_type
      }
      nextToken
    }
  }
`,
};

/*****************************************************************************
 * CAP ASSIST - DRIVER CONCERN
 ****************************************************************************/
export const DriverConcernQueries = {
  query: `
  query listDriverConcern{
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpDriverConcern} {
     items {
      id
      driver_id
      username
      user_pid
      user_display_name
      driver_username
      driver_display_name
      concern_type
      comments{
        date
        des
        status
        exdata
      }
      feedback
      req_date
      request_id
      request_status
      satisfaction
      user_text
      ex_data
      sla_date
      created_date
      updated_date
      created_type
      rncuser_id
      ticket_id
     }
     nextToken
    }
  }
`,
};

export const updateDriverConcernQueries = {
  mutation: `
  mutation updateDriverConcern(
    $id: ID!;
    $driver_id: String;
    $username: String;
    $user_pid: String;
    $user_display_name: String;
    $driver_username: String;
    $driver_display_name: String;
    $concern_type: [String];
    $comments: [HouseCommentsMap];
    $feedback: String;
    $req_date: String;
    $request_id: String;
    $request_status: String;
    $satisfaction: String;
    $user_text: String;
    $ex_data: String;
    $sla_date: String;
    $created_date: String;
    $updated_date: String;
    $created_type: String;
    $rncuser_id: String;
    $ticket_id: String;
  ) {
    ${AppConstants.update}${environment.dbPrefix}${AppConstants.updateCpDriverConcern}(input: {
      id: $id;
      driver_id: $driver_id;
      username: $username;
      user_pid: $user_pid;
      user_display_name: $user_display_name;
      driver_username: $driver_username;
      driver_display_name: $driver_display_name;
      concern_type: $concern_type;
      comments: $comments;
      feedback: $feedback;
      req_date: $req_date;
      request_id: $request_id;
      request_status: $request_status;
      satisfaction: $satisfaction;
      user_text: $user_text;
      ex_data: $ex_data;
      sla_date: $sla_date;
      created_date: $created_date;
      updated_date: $updated_date;
      created_type: $created_type;
      rncuser_id: $rncuser_id;
      ticket_id: $ticket_id;
    }) {
      id
      driver_id
      username
      user_pid
      user_display_name
      driver_username
      driver_display_name
      concern_type
      comments
      feedback
      req_date
      request_id
      request_status
      satisfaction
      user_text
      ex_data
      sla_date
      created_date
      updated_date
      created_type
      rncuser_id
      ticket_id
    }
  }
`,
};

export const DriverFeedbackQueries = {
  query: `
  query listDriverFeedback{
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpDriverFeedback} {
     items {
      id
      driver_id
      appreciation
      rating
      report
      comments
      alternate_driver_request
      alternate_driver_request_status
      request_comments
      submitted_by
      created_on
      updated_on
     }
     nextToken
    }
  }
`,
};
